
import React from 'react';

export const POLICY_CONTENT = {
    terms: {
        title: 'Terms and Conditions',
        content: (
            <div>
                <div className="policy-section">
                    <h3>Agreement to Terms</h3>
                    <p>This is a placeholder for the Terms and Conditions. Please replace this with the actual terms.</p>
                </div>
                <div className="policy-section">
                    <h3>Intellectual Property Rights</h3>
                    <p>Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site represent our intellectual property.</p>
                </div>
            </div>
        )
    },
    privacy: {
        title: 'Privacy Policy',
        content: (
            <div>
                <div className="policy-section">
                    <p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</p>
                    <p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the Free Privacy Policy Generator.</p>
                </div>

                <div className="policy-section">
                    <h3>Interpretation and Definitions</h3>
                    <h4>Interpretation</h4>
                    <p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
                </div>

                <div className="policy-section">
                    <h4>Definitions</h4>
                    <p>For the purposes of this Privacy Policy:</p>
                    <ul className="policy-list">
                        <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
                        <li><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</li>
                        <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Accell Inc, Alpharetta, Georgia.</li>
                        <li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
                        <li><strong>Country</strong> refers to: Georgia, United States</li>
                        <li><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
                    </ul>
                </div>
            </div>
        )
    },
    cookie: {
        title: 'Cookie Policy',
        content: (
            <div>
                <div className="policy-section">
                    <h3>Use of Cookies</h3>
                    <p>This is a placeholder for the Cookie Policy. Please replace this with the actual cookie policy.</p>
                </div>
                <div className="policy-section">
                    <h3>Types of Cookies</h3>
                    <p>We use both session and persistent cookies on the Service and we use different types of cookies to run the Service: Essential, Analytics, and Advertising cookies.</p>
                </div>
            </div>
        )
    }
};
